;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputTextController', InputTextController)

  /* @ngInject */
  function InputTextController ($scope, Utils) {
    const api = {
      _checkForLinks
    }
    this.getApi = () => api

    activate()

    function activate () {
      api._checkForLinks()
    }

    $scope.onChange = function (newValue) {
      if ($scope.maxLength && $scope.maxLength > 0 && newValue.length > $scope.maxLength) {
        $scope.model = newValue.substring(0, $scope.maxLength)
      }

      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    $scope.onInputBlur = function () {
      if ($scope.blur) {
        $scope.blur()
      }
    }

    $scope.copyText = function () {
      const copyText = document.getElementsByClassName('copy-input')

      copyText[0].select()
      copyText[0].setSelectionRange(0, 99999)

      document.execCommand('copy')
    }

    $scope.onKeydownInput = function ($event) {
      if ($event.keyCode === 13) {
        if ($scope.onKeyDown) {
          $scope.onKeyDown()
        }
      }
    }

    $scope.onClearClick = function () {
      if ($scope.onClear) {
        $scope.onClear()
      }
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }
  }
})()
